import { render, staticRenderFns } from "./TrsUrlImport.vue?vue&type=template&id=c21842f6"
import script from "./TrsUrlImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrsUrlImport.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports